import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Stack
} from '@mui/material';
import {
  authService,
  BaseOnboardingTemplate,
  fields,
  imageUtil,
  ResponsiveImage,
  routeDirectory,
  validationUtil
} from 'modules';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';



const imgsEmail = imageUtil.getUrlSet('email', 'png');

const __formSchema = yup.object({
  email: validationUtil.emailSchema.required('Email is required.')
}).required();

type IFormData = yup.InferType<typeof __formSchema>;

const ControlledTextField = fields.genTextFieldControllerComponent<IFormData>();



export interface IForgotPasswordActivityProps {}

export const ForgotPasswordActivity: React.FC<IForgotPasswordActivityProps> = props => {
  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema)
  });
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);



  async function processSubmit(data: IFormData) {
    setLoading(true);
    await authService.forgotPassword(data.email);
    setLoading(false);
    navigate(routeDirectory.authentication.resetPassword.path(data.email));
  }



  return (
    <BaseOnboardingTemplate.FC
      stepperMode="none"
      title="Forgot Password"
      subtitle="Please enter the email address associated with your account below and we will send you instructions on how to reset it.">

      <form onSubmit={form.handleSubmit(processSubmit)}>
        <Stack spacing={7}>
          <ControlledTextField
            formControl={form.control}
            fieldKey="email"
            label="Email"
            startAdornment={<ResponsiveImage.FC urlSet={imgsEmail} />} />

          <Stack
            direction="row"
            justifyContent="space-between">
            <Button
              color="secondary"
              variant="outlined"
              disabled={loading}
              onClick={() => navigate(-1)}>
              Back
            </Button>

            <Button
              type="submit"
              disabled={loading}>
              Next
            </Button>
          </Stack>
        </Stack>
      </form>

    </BaseOnboardingTemplate.FC>
  );
};
